import { useMediaQuery, Button } from '@mui/material';
import { useAccount } from '../../contexts/Account';
import { getAdvisorQueryParams } from '../../utils/queryParams';
import eventBus, { eventBusValues } from '../../eventBus';

const useStyles = () => ({
  floatingButton: {
    bottom: '20px',
    left: '50%',
    width: '400px',
    transform: 'translateX(-50%)',
    height: '36px',
    fontSize: '15px',
  },
  stickyButton: {
    bottom: 0,
    left: 0,
    width: '100%',
    textAlign: 'center',
    borderRadius: '0px',
    height: '44px',
    fontSize: '16px',
  },
});

function GetAssistanceButton() {
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const { accountDetails, isFreeTrial, isFreemium } = useAccount();
  const classes = useStyles();

  function handleClick() {
    if (isFreemium) {
      eventBus.dispatch(eventBusValues.triggerAdvisorUpgradeAction, {
        origin: 'directory-button',
      });
    } else {
      window.location.replace(
        `https://register.advisorycloud.com/get-assistance-boards?${getAdvisorQueryParams(
          {
            accountDetails,
            isFreeTrial,
            isFreemium,
          }
        )}`
      );
    }
  }

  return (
    <Button
      variant="contained"
      color="primary"
      fullWidth={isXS}
      sx={{
        position: 'fixed',
        zIndex: 1000,
        ...(isXS ? classes.stickyButton : classes.floatingButton),
        fontWeight: 600,
      }}
      onClick={handleClick}
    >
      Recommend Top Matches
    </Button>
  );
}

export default GetAssistanceButton;
